import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const User14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 1.25C5.50217 1.25 4.25 2.50217 4.25 4C4.25 5.49783 5.50217 6.75 7 6.75C8.49783 6.75 9.75 5.49783 9.75 4C9.75 2.50217 8.49783 1.25 7 1.25ZM7 2.75C7.68083 2.75 8.25 3.31917 8.25 4C8.25 4.68083 7.68083 5.25 7 5.25C6.31917 5.25 5.75 4.68083 5.75 4C5.75 3.31917 6.31917 2.75 7 2.75Z'
      fill='currentColor'
    />
    <path
      d='M2.75 10.0001C2.75 9.30971 3.30964 8.75006 4 8.75006H10C10.6904 8.75006 11.25 9.30971 11.25 10.0001V12.0001H12.75V10.0001C12.75 8.48128 11.5188 7.25006 10 7.25006H4C2.48122 7.25006 1.25 8.48128 1.25 10.0001V12.0001H2.75V10.0001Z'
      fill='currentColor'
    />
  </Svg>
);

User14.displayName = 'User14';
export default User14;
